//
// Copyright (c) 2011-2019 by Curalate, Inc.
//
import { IUrlRouterProvider } from 'angular-ui-router';

import {
    componentNameToTemplate,
    hasFeature,
    IPartialState,
    lazyLoadModule,
    NavGroup,
    StateFactory,
} from 'app/initialization/routing/stateHelpers';

import { crl8 } from 'app/curalate.globals';
import './syndication-page/syndication-page';

function ShareStateFactory(state: IPartialState) {
  const data = {
    navGroup: NavGroup.MEDIA,
    title: 'Share',
    allowSyndicationClients: true,
    ...state.data,
    hasAccess: () => hasFeature('syndication') || !!crl8.session?.client.isSyndication,
  };
  return StateFactory({
    ...state,
    data,
  });
}

export function routingRules(urlRouterProvider: IUrlRouterProvider) {
  urlRouterProvider.when('/share', '/share/summary');
}

export const states = {
  syndication: ShareStateFactory({
    abstract: true,
    url: '/share',
    template: componentNameToTemplate('syndicationPage'),
    data: {
      title: 'Share',
    },
    resolve: {
      ...lazyLoadModule('curalate.syndication', () => import('./syndication.app')),
    },
  }),
  'syndication.summary': ShareStateFactory({
    url: '/summary',
    template: componentNameToTemplate('syndicationSummaryView'),
    data: {
      title: 'Share - Summary',
    },
  }),
  'syndication.creatorDetail': ShareStateFactory({
    url: '/:folderOwner/:creatorClientId/:publisherClientId',
    template: componentNameToTemplate('syndicationDetailView'),
    data: {
      title: 'Share - Detail',
    },
  }),
  'syndication.inbox': ShareStateFactory({
    url: '/inbox',
    template: componentNameToTemplate('syndicationInboxView'),
    data: {
      title: 'Share - Inbox',
    },
  }),
  'syndication.outbox': ShareStateFactory({
    url: '/outbox',
    template: componentNameToTemplate('syndicationOutboxView'),
    data: {
      title: 'Share - Outbox',
    },
  }),
  'syndication.settings': ShareStateFactory({
    url: '/settings',
    template: componentNameToTemplate('syndicationSettingsView'),
    data: {
      title: 'Share - Settings',
    },
  }),
};
